import React from 'react';
import { motion } from 'framer-motion';
import { Truck, Clock, Shield, Phone, Package, RotateCcw } from 'lucide-react';

const Features = () => {
  const features = [
    {
      icon: Truck,
      title: 'Free Delivery',
      desc: 'On all orders over £30 across the UK',
      color: 'bg-blue-500',
      lightColor: 'bg-blue-50',
      textColor: 'text-blue-600',
    },
    {
      icon: Clock,
      title: 'Next Day Delivery',
      desc: 'Order before 5PM for next day arrival',
      color: 'bg-green-500',
      lightColor: 'bg-green-50',
      textColor: 'text-green-600',
    },
    {
      icon: Shield,
      title: 'Fresh Guarantee',
      desc: '100% quality assured or money back',
      color: 'bg-primary-500',
      lightColor: 'bg-primary-50',
      textColor: 'text-primary-600',
    },
    {
      icon: Phone,
      title: 'WhatsApp Support',
      desc: 'Quick & easy ordering via WhatsApp',
      color: 'bg-purple-500',
      lightColor: 'bg-purple-50',
      textColor: 'text-purple-600',
    },
    {
      icon: Package,
      title: 'Secure Packaging',
      desc: 'Carefully packed for safe delivery',
      color: 'bg-teal-500',
      lightColor: 'bg-teal-50',
      textColor: 'text-teal-600',
    },
    {
      icon: RotateCcw,
      title: 'Easy Returns',
      desc: 'Hassle-free 7-day return policy',
      color: 'bg-rose-500',
      lightColor: 'bg-rose-50',
      textColor: 'text-rose-600',
    },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <motion.div
              key={feature.title}
              className={`${feature.lightColor} rounded-2xl p-6 flex items-start gap-4 group cursor-pointer`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-50px' }}
              transition={{ delay: index * 0.1 }}
              whileHover={{ y: -5, scale: 1.02 }}
            >
              <div className={`${feature.color} p-3 rounded-xl text-white shadow-lg group-hover:shadow-xl transition-shadow`}>
                <feature.icon size={24} />
              </div>
              <div>
                <h3 className={`font-bold text-gray-900 text-lg ${feature.textColor}`}>{feature.title}</h3>
                <p className="text-gray-500 text-sm mt-1 leading-relaxed">{feature.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
